import React from "react";
import {
  SiDbt,
  SiFastapi,
  SiOpenai,
  SiPostgresql,
  SiPython,
  SiReact,
  SiSnowflake,
  SiTypescript,
  SiVercel,
} from "react-icons/si";

import { useLanguage } from "../context/LanguageContext";

const technologies = [
  { name: "dbt", icon: SiDbt, stage: "data", left: "4%", top: "10%", size: 27, driftX: "6px", driftY: "-4px", duration: "7.5s", delay: "-2s" },
  { name: "PostgreSQL", icon: SiPostgresql, stage: "data", left: "18%", top: "22%", size: 30, driftX: "-5px", driftY: "6px", duration: "8.4s", delay: "-4s" },
  { name: "Snowflake", icon: SiSnowflake, stage: "data", left: "42%", top: "9%", size: 31, driftX: "4px", driftY: "5px", duration: "6.8s", delay: "-1s" },
  { name: "OpenAI", icon: SiOpenai, stage: "ai", left: "66%", top: "7%", size: 31, driftX: "-4px", driftY: "-6px", duration: "7.8s", delay: "-3s" },
  { name: "Python", icon: SiPython, stage: "ai", left: "92%", top: "12%", size: 30, driftX: "6px", driftY: "3px", duration: "8.8s", delay: "-5s" },
  { name: "FastAPI", icon: SiFastapi, stage: "ai", left: "4%", top: "52%", size: 28, driftX: "5px", driftY: "-5px", duration: "7.2s", delay: "-2s" },
  { name: "React", icon: SiReact, stage: "ship", left: "48%", top: "86%", size: 31, driftX: "-6px", driftY: "4px", duration: "9s", delay: "-6s" },
  { name: "TypeScript", icon: SiTypescript, stage: "ship", left: "92%", top: "50%", size: 29, driftX: "4px", driftY: "-4px", duration: "8.2s", delay: "-3s" },
  { name: "Vercel", icon: SiVercel, stage: "ship", left: "84%", top: "91%", size: 30, driftX: "-5px", driftY: "-3px", duration: "7.6s", delay: "-1s" },
];

export default function TechConstellation({ activeStage, onStageChange }) {
  const { strings, isZh } = useLanguage();
  const tc = strings?.techConstellation;
  const stageLabels = {
    data: tc?.data || "Trusted data",
    ai: tc?.ai || "AI system",
    ship: tc?.ship || "Shipped product",
  };
  const ariaContainerLabel = tc?.ariaLabel || "Technologies used across the product system";
  const techSuffix = tc?.technologySuffix || "technology";

  return (
    <div className="tech-constellation absolute inset-0 z-0 hidden overflow-hidden lg:block" aria-label={ariaContainerLabel}>
      {technologies.map((technology) => {
        const Icon = technology.icon;
        const isStageActive = activeStage === technology.stage;
        const buttonAria = isZh
          ? `${technology.name} · ${stageLabels[technology.stage]} ${techSuffix}`
          : `${technology.name}. ${stageLabels[technology.stage]} ${techSuffix}`;

        return (
          <button
            key={technology.name}
            type="button"
            className="tech-constellation-item"
            style={{
              left: technology.left,
              top: technology.top,
              "--tech-logo-size": `${technology.size}px`,
              "--tech-drift-x": technology.driftX,
              "--tech-drift-y": technology.driftY,
              "--tech-drift-duration": technology.duration,
              "--tech-drift-delay": technology.delay,
            }}
            data-stage-active={isStageActive ? "true" : "false"}
            aria-label={buttonAria}
            onMouseEnter={() => onStageChange(technology.stage)}
            onMouseLeave={() => onStageChange(null)}
            onFocus={() => onStageChange(technology.stage)}
            onBlur={() => onStageChange(null)}
          >
            <Icon className="tech-constellation-logo" aria-hidden="true" />
            <span className="tech-constellation-label">{technology.name}</span>
          </button>
        );
      })}
    </div>
  );
}

export { technologies as techConstellationItems };
